// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Qvt-3","title":"styles_title__oZ3sa","message":"styles_message__CW-Q7"};